import React from 'react'
import clxs from 'clsx'
import { Button, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { Bold } from '~/components'
import { ArrowLeftIcon } from '~/assets/icons'
import { mutualTheme } from '~/utils/theme'

const useStyles = makeStyles({
  button: {
    textTransform: 'none',
    color: mutualTheme.palette.secondary.main
  }
})

export type BackButtonProps = {
  className?: string,
  onBackButtonClick: () => void
}

export const BackButton: React.FC<BackButtonProps> = (props) => {
  const { className, onBackButtonClick } = props
  const classes = useStyles()

  return (
    <Button
      startIcon={<ArrowLeftIcon />}
      onClick={onBackButtonClick}
      className={clxs(classes.button, className)}
    >
      <Typography variant='airbnbBody1'>
        <Bold>Voltar</Bold>
      </Typography>
    </Button>
  )
}
